/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PopupHeader from '../../common/PopupHeader';
import { SuccessMessage } from '../../common';
import * as api from '../../../epics/api';

import history from '../../../history';

class ClientCheckoutLinkModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            copied: false,
            job: null,
        };
        this.copyLink = this.copyLink.bind(this);
    }

    componentDidMount() {
        const { jobId } = this.props.match.params;
        api.executeHttpRequest(`jobs/${jobId}`)
            .then(response => {
                const job = response.data.content;
                this.setState({ job });
            })
            .catch(response => {
                console.log(response);
            });
    }

    onDismiss = () => {
        history.goBack();
    };

    copyLink() {
        navigator.clipboard.writeText(this.inputText.value);
        this.setState({ copied: true });
    }

    render() {
        if (this.state.job) {
            return (
                <div className="client-checkout-link-modal">
                    <div>
                        <PopupHeader
                            title="Checkout link"
                            onDismiss={this.onDismiss}
                        />
                        <p>
                            The link below allows your
                            {this.props.user.features &&
                            this.props.user.features.includes('self_managed')
                                ? ' venue managers '
                                : ' clients '}
                            to be be redirected to checkout page where payment
                            can be entered.
                        </p>
                        <input
                            className="link-input"
                            type="text"
                            name="link"
                            readOnly={true}
                            value={this.state.job.client_checkout_link}
                            ref={inputText => (this.inputText = inputText)}
                        />

                        <div className="modal-bottom-bar">
                            <button
                                className="table-action-button"
                                onClick={this.copyLink}
                            >
                                Copy link
                            </button>
                        </div>
                    </div>
                    {this.state.copied ? (
                        <SuccessMessage message="Copied to clipboard!" />
                    ) : null}
                </div>
            );
        }
        return <div />;
    }
}

const mapStateToProps = state => ({
    user: state.user,
});

export default connect(mapStateToProps, {})(ClientCheckoutLinkModal);
